'use strict';

var smoothScroll = {

	init: function () {
		var links = document.querySelectorAll('.js-smooth-scroll');

		if (!links.length) return;

		links.forEach(function(link) {
			link.addEventListener('click', function (e) {
				var el = document.getElementById(link.getAttribute('href').replace('#', ''));
				if (el === undefined || el === null) return;
				var bounds = el.getBoundingClientRect();
				var top = parseInt(bounds.top, 10);
				if (top < 1) {
					top = 0;
				}
				window.scroll({ top: top, behavior: 'smooth' });
				e.preventDefault();
			});
		});
	}

};

window.addEventListener('load', smoothScroll.init());